export default () => {
  const contactForm = document.getElementById('js-kurs-form')
  const responeNode = document.getElementById('js-contact-form-response')

  const handleFormSubmitted = response => {
    if (response.status === 200) {
      responeNode.innerHTML =
        'Tusen takk! Din henvendelse ble sendt. Du hører fra oss!'
      contactForm.reset()
    }
  }

  const handleFormError = error => {
    console.warn(error)
  }

  window.onContactFormSubmit = function() {
    console.log('send')
    if (document.getElementById('g-recaptcha-response').value !== '') {
      console.log('here sending')
      let data = new FormData(contactForm)
      const fromEmail = data.get('fromEmail')
      data.append('toEmail', fromEmail)

      fetch('/', {
        method: 'POST',
        headers: {
          Accepts: 'application/json'
        },
        body: new URLSearchParams(data)
      })
        .then(handleFormSubmitted)
        .catch(handleFormError)
    }
  }
}
